import { reactNode } from '@shared/node-v1.0.0'

import v200 from '@nodes/image-v2.0.0'

export default reactNode(
	'Image',
	{
		'v2.0.0': v200,
	},
	{ docs: '' }
)
